import { Linking } from 'react-native'

import { IRequestData } from '../../api/functions/customerAdditionStateMachine'

export type statesType = {
  SHOW_RECOMMENDATION_SCREEN: string
  SHOW_EMPLOYMENT_DETAILS_SCREEN: string
  SHOW_PAN_COLLECTION_SCREEN: string
  SHOW_BASIC_DETAILS_SCREEN: string
  SHOW_OTP_SCREEN: string
  SHOW_PHONE_NUMBER_SCREEN: string
  SHOW_BASIC_DETAILS_SCREEN_V2: string
  SHOW_PAN_COLLECTION_SCREEN_V2: string
  SHOW_OTP_LESS_SCREEN?: string
  SHOW_PHONE_CALL_SCREEN: string
  SHOW_SECONDARY_PHONE_NUMBER_SCREEN: string
  SHOW_SECONDARY_OTP_SCREEN: string
  SHOW_QUICK_PAN_SCREEN: string
  SHOW_QUICK_RECOMMENDATION_SCREEN: string
  SHOW_QUICK_OTP_SCREEN: string
  SHOW_QUICK_BASIC_DETAILS_SCREEN: string
  SHOW_PRIMARY_DETAILS_SCREEN_JFS: string
  SHOW_BASIC_DETAILS_SCREEN_JFS: string
  SHOW_PAN_SCREEN_JFS: string
}

export const states: statesType = {
  SHOW_RECOMMENDATION_SCREEN: 'BrandPage',
  SHOW_EMPLOYMENT_DETAILS_SCREEN: 'EmploymentDetails',
  SHOW_PAN_COLLECTION_SCREEN: 'PanDetails',
  SHOW_PAN_COLLECTION_SCREEN_V2: 'PanDetailsV2',
  SHOW_BASIC_DETAILS_SCREEN: 'CustomerBasicDetails',
  SHOW_BASIC_DETAILS_SCREEN_V2: 'CustomerBasicDetailsV2',
  SHOW_OTP_SCREEN: 'VerifyCustomerOtp',
  SHOW_PHONE_NUMBER_SCREEN: 'KnowYourCustomer',
  SHOW_OTP_LESS_SCREEN: 'OtpLess',
  SHOW_PHONE_CALL_SCREEN: 'VerifyCustomerConsentScreen',
  SHOW_SECONDARY_PHONE_NUMBER_SCREEN: 'VerifySecondaryPhoneNumber',
  SHOW_SECONDARY_OTP_SCREEN: 'VerifySecondaryPhoneOtp',
}

export const webStates: statesType = {
  SHOW_RECOMMENDATION_SCREEN: 'BrandPage',
  SHOW_EMPLOYMENT_DETAILS_SCREEN: 'EmploymentDetailsWF',
  SHOW_PAN_COLLECTION_SCREEN: 'PanDetails',
  SHOW_PAN_COLLECTION_SCREEN_V2: 'PanDetailsV2',
  SHOW_BASIC_DETAILS_SCREEN: 'BasicDetails',
  SHOW_BASIC_DETAILS_SCREEN_V2: 'CustomerBasicDetailsV2',
  SHOW_OTP_SCREEN: 'OtpScreen',
  SHOW_PHONE_NUMBER_SCREEN: 'KnowYourCustomer',
  SHOW_SECONDARY_PHONE_NUMBER_SCREEN: 'VerifySecondaryPhoneNumber',
  SHOW_SECONDARY_OTP_SCREEN: 'VerifySecondaryPhoneOtp',
  SHOW_QUICK_BASIC_DETAILS_SCREEN: 'QuickCustomerDetails',
  SHOW_QUICK_PAN_SCREEN: 'QuickJourneyPanDetails',
  SHOW_QUICK_RECOMMENDATION_SCREEN: 'BrandPage',
  SHOW_QUICK_OTP_SCREEN: 'OtpVerification',
  SHOW_PRIMARY_DETAILS_SCREEN_JFS: 'CustomerInfo',
  SHOW_BASIC_DETAILS_SCREEN_JFS: 'CustomerBasicDetails',
  SHOW_PAN_SCREEN_JFS: 'CustomerPanDetails',
}

export const getRequestDataFormat = (data: IRequestData) => {
  const {
    fullName,
    phoneNumber,
    customerId,
    otp,
    employmentType,
    bankNameList,
    currentOccupation,
    annualIncome,
    modeOfIncome,
    dob,
    pinCode,
    email,
    gender,
    screenName,
    panNo,
    partnerId,
    isReconsentFlow,
    customerIntent,
    event,
    meta,
    isCreditCheck,
    nonVerifiedBridgeCustomerAddition,
    customerAdditionSource,
    isDemoSale,
    subagentId,
    secondaryPhoneNumber,
  } = data
  switch (screenName) {
    case 'SHOWN_PHONE_NUMBER_SCREEN':
      if (isReconsentFlow) {
        return {
          customerPayload: {
            fullName,
            phoneNumber,
            meta,
            customerIntentList: [customerIntent],
            customerAdditionSource,
            isDemoSale,
            email,
          },
          bureauReportConsent: true,
          userState: screenName,
          nonVerifiedBridgeCustomerAddition,
          subagentId,
        }
      } else if (isCreditCheck) {
        return {
          customerPayload: {
            fullName,
            phoneNumber,
            meta,
            customerIntentList: [customerIntent],
            customerAdditionSource,
            isDemoSale,
            email,
          },
          isCreditCheck: true,
          userState: screenName,
          nonVerifiedBridgeCustomerAddition,
        }
      } else {
        return {
          customerPayload: {
            fullName,
            phoneNumber,
            meta,
            customerIntentList: [customerIntent],
            customerAdditionSource,
            isDemoSale,
            email,
          },
          userState: screenName,
          nonVerifiedBridgeCustomerAddition,
          subagentId,
        }
      }
    case 'SHOWN_PHONE_CALL_SCREEN':
      if (isReconsentFlow) {
        return {
          customerPayload: {
            fullName,
            phoneNumber,
            customerId,
            isDemoSale,
          },
          bureauReportConsent: true,
          userState: screenName,
          nonVerifiedBridgeCustomerAddition,
        }
      } else {
        return {
          customerPayload: { fullName, phoneNumber, customerId, isDemoSale },
          userState: screenName,
          nonVerifiedBridgeCustomerAddition,
        }
      }
    case 'SHOWN_OTP_SCREEN':
      if (isReconsentFlow) {
        return {
          customerPayload: {
            customerId,
            otp,
            phoneNumber,
            isDemoSale,
          },
          bureauReportConsent: true,
          userState: screenName,
          subagentId,
        }
      } else if (isCreditCheck) {
        return {
          customerPayload: {
            customerId,
            otp,
            phoneNumber,
            isDemoSale,
          },
          isCreditCheck: true,
          userState: screenName,
        }
      } else {
        return {
          customerPayload: { customerId, otp, phoneNumber, isDemoSale },
          userState: screenName,
        }
      }
    case 'SHOWN_BASIC_DETAILS_SCREEN':
      return {
        customerPayload: {
          customerId,
          modeOfIncome,
          dob,
          pinCode,
          gender,
          isDemoSale,
        },
        userState: screenName,
      }
    case 'SHOWN_BASIC_DETAILS_SCREEN_V2':
      return {
        customerPayload: {
          customerId,
          modeOfIncome,
          pinCode,
          gender,
          employmentType,
          annualIncome,
          isDemoSale,
        },
        userState: screenName,
      }
    case 'SHOWN_PAN_COLLECTION_SCREEN':
      return {
        customerPayload: { customerId, panNo, isDemoSale },
        userState: screenName,
      }
    case 'SHOWN_PAN_COLLECTION_SCREEN_V2':
      return {
        customerPayload: { customerId, panNo, dob, isDemoSale },
        userState: screenName,
      }
    case 'SHOWN_EMPLOYMENT_DETAILS_SCREEN':
      if (partnerId) {
        return {
          customerPayload: {
            customerId,
            employmentType,
            bankNameList,
            currentOccupation,
            annualIncome,
            isDemoSale,
          },
          partnerId,
          userState: screenName,
        }
      } else {
        return {
          customerPayload: {
            customerId,
            employmentType,
            bankNameList,
            currentOccupation,
            annualIncome,
            isDemoSale,
          },
          userState: screenName,
        }
      }
    case 'BACK':
      return {
        customerPayload: {
          customerId,
          isDemoSale,
        },
        userState: screenName,
      }
    case 'GET_CURRENT_STATE':
      return {
        customerPayload: {
          customerId,
          isDemoSale,
        },
        userState: screenName,
      }
    case 'SHOWN_OTP_LESS_SCREEN':
      return {
        customerPayload: {
          customerId,
          isDemoSale,
        },
        event,
        userState: screenName,
      }
    case 'SHOWN_SECONDARY_PHONE_NUMBER_SCREEN':
      return {
        customerPayload: {
          secondaryPhoneNumber,
          customerId,
        },
        userState: screenName,
      }
    case 'SHOWN_SECONDARY_OTP_SCREEN':
      return {
        customerPayload: { customerId, otp, secondaryPhoneNumber },
        userState: screenName,
      }
    default:
      return {
        customerPayload: { fullName, phoneNumber, isDemoSale },
        userState: 'SHOWN_PHONE_NUMBER_SCREEN',
      }
  }
}

export const URL_PATH = [
  '/customer/check-credit-score',
  '/customer/login',
  '/customer/otpVerify',
]

export function linkCall(mobNumber: string | undefined) {
  Linking.openURL(`tel:${mobNumber}`)
}

export const CATEGORY = {
  LOANS: 'LOANS',
  CREDIT_CARD: 'CARDS',
}

export type ICATEGORY = 'LOANS' | 'CARDS'

export const CUSTOMER_SOURCE = {
  DEMO_SELL: 'demoSale',
  SELF_ADD_CUSTOMER: 'selfAddCustomer',
}
